var XPortal = XPortal || {};

XPortal.PlaceFooterBtns = (function () {
    var self = {};

    const selector = '.edit-btns-wrapper_footer';
    const activeClass = 'at-bottom';
    let intervalId;

    self.Init = function () {
        if (intervalId) return;

        intervalId = setInterval(() => {
            const footer = document.querySelector(selector);
            if (!footer) return;

            clearInterval(intervalId);

            const getMaxScroll = () =>
                Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

            const isAtBottom = () => {
              const maxScroll = getMaxScroll();
              if (maxScroll <= 0) return false; 
              return window.scrollY >= maxScroll - 2;
            };

            const onScrollOrResize = () => {
                footer.classList.toggle(activeClass, isAtBottom());
            };

            window.addEventListener('scroll', onScrollOrResize, { passive: true });
            window.addEventListener('resize', onScrollOrResize);
            requestAnimationFrame(onScrollOrResize);
            window.addEventListener('load', onScrollOrResize, { once: true });

        }, 300);
    };

    return self;
})();
